<template>
  <div class="container-fluid">
    <div class="d-flex justify-content-between align-items-center mb-2">
      <h6 class="bold text-secondary-light m-0">Language Information</h6>
      <!-- <i class="fa-solid fa-pen-to-square text-primary"></i> -->
    </div>

    <div v-if="LanguageSpokenInfo.length">
      <div class="br-8 table-scroll-wrapper">
        <table
          class="table table-inner-bordered m-0 align-middle text-start bg-blue-light-2 br-8"
        >
          <tbody>
            <tr>
              <td v-for="(data, index) in LanguageSpokenInfo" :key="index">
                <span
                  :class="data.language ? 'text-secondary bold' : 'text-muted'"
                >
                  {{
                    data.language +
                    `${data.proficiency ? ` - ${data.proficiency}` : ""}`
                  }}
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div v-else class="text-center">
      <label class="text-muted">
        <i class="fa-solid fa-ban"></i>
        No Languages Found
      </label>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "CandidateLanguageInfo_1",
  computed: {
    ...mapGetters(["getCandidateLanguage"]),
    LanguageSpokenInfo() {
      return (
        this.getCandidateLanguage.map(
          ({
            language_id,
            candidate_language_id,
            language,
            language_proficiency,
            comments,
          }) => {
            return {
              language_id: language.language_id,
              candidate_language_id: candidate_language_id,
              language: language.language,
              proficiency: language_proficiency?.proficiency,
              comments: comments,
            };
          }
        ) || []
      );
    },
  },
};
</script>
